import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import {
  FiCheck,
  FiChevronLeft,
  FiChevronRight,
  FiPhone,
  FiCalendar,
  FiTarget,
  FiHeart,
  FiEye,
  FiUsers,
} from "react-icons/fi";
import { BiBrain } from "react-icons/bi";

const Dir = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const topRef = useRef(null);

  const images = [
    "/img/services-detail/dir1.jpg",
    "/img/services-detail/dir2.jpg",
  ];

  const services = [
    {
      icon: BiBrain,
      title: "Bireyselleştirilmiş Oyun Terapisi",
      description:
        "Çocuğun yaşına, gelişim düzeyine ve ilgi alanına göre özel oyun aktiviteleri planlama ve uygulama.",
    },
    {
      icon: FiUsers,
      title: "Sosyal İletişim Becerileri",
      description:
        "Göz teması, paylaşım, duygu ifade etme ve başkalarıyla etkileşim yeteneklerini güçlendirme.",
    },
    {
      icon: FiTarget,
      title: "Dikkat ve Odaklanma Desteği",
      description:
        "DEHB olan çocuklarda dikkat süresi ve konsantrasyonu artırmaya yönelik etkinlikler.",
    },
    {
      icon: FiHeart,
      title: "Duygusal Farkındalık",
      description:
        "Öfke, kaygı, hayal kırıklığı gibi duyguların tanınması, ifade edilmesi ve yönetilmesini sağlama.",
    },
  ];

  const additionalServices = [
    "Bilişsel ve problem çözme becerileri geliştirme",
    "Duyusal ve motor gelişim desteği",
    "Sosyal beceri ve oyun etkileşimi",
    "Aile rehberliği ve ev stratejileri",
    "Gelişim hedeflerinin planlanması ve takibi",
  ];

  const targetGroups = [
    "Otizm spektrumunda olan çocuklar",
    "DEHB'li çocuklar",
    "Sosyal-davranışsal gelişim desteğine ihtiyaç duyan çocuklar",
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Auto slide
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [images.length]);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % images.length);
  const prevSlide = () =>
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);

  return (
    <section
      ref={topRef}
      style={{
        paddingTop: "140px",
        paddingBottom: "80px",
        backgroundColor: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      <Helmet>
        <title>
          DIRFloortime Terapisi | Dilan Aslan | Çocuk Gelişim Danışmanlığı
        </title>
        <meta
          name="description"
          content="DIRFloortime terapi yöntemi ile otizm, DEHB ve gelişim desteğine ihtiyaç duyan çocuklara özel oyun temelli terapi hizmetleri."
        />
      </Helmet>

      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}>
        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          style={{
            background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
            borderRadius: "24px",
            padding: "48px",
            marginBottom: "48px",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Decorative circles */}
          <div
            style={{
              position: "absolute",
              top: "-50px",
              right: "-50px",
              width: "200px",
              height: "200px",
              background:
                "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
              borderRadius: "50%",
            }}
          />

          <div style={{ position: "relative", zIndex: 1 }}>
            <span
              style={{
                display: "inline-block",
                backgroundColor: "rgba(255,255,255,0.2)",
                color: "#d1fae5",
                padding: "8px 16px",
                borderRadius: "50px",
                fontSize: "0.85rem",
                fontWeight: "600",
                marginBottom: "16px",
              }}
            >
              OYUN TEMELLİ TERAPİ
            </span>
            <h1
              style={{
                fontSize: "2.5rem",
                fontWeight: "800",
                color: "white",
                marginBottom: "16px",
                lineHeight: "1.2",
              }}
            >
              DIRFloortime Terapisi
            </h1>
            <p
              style={{
                fontSize: "1.1rem",
                color: "#a7f3d0",
                maxWidth: "600px",
                lineHeight: "1.7",
                marginBottom: "24px",
              }}
            >
              Çocuğunuzun benzersiz gelişim profiline göre tasarlanmış, ilişki
              temelli ve oyun odaklı terapi yaklaşımı.
            </p>
            <a
              href="#contact"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "white",
                color: "#059669",
                padding: "14px 28px",
                borderRadius: "12px",
                fontWeight: "600",
                textDecoration: "none",
                fontSize: "0.95rem",
              }}
            >
              <FiCalendar size={18} />
              Randevu Al
            </a>
          </div>
        </motion.div>

        {/* Hedef Kitle */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          style={{
            backgroundColor: "#fef3c7",
            borderRadius: "16px",
            padding: "24px",
            marginBottom: "32px",
            border: "1px solid #fcd34d",
          }}
        >
          <h3
            style={{
              fontSize: "1.1rem",
              fontWeight: "600",
              color: "#92400e",
              marginBottom: "12px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <FiEye size={20} />
            Hedef Kitle
          </h3>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
            {targetGroups.map((group, index) => (
              <span
                key={index}
                style={{
                  backgroundColor: "white",
                  color: "#92400e",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  fontSize: "0.9rem",
                  fontWeight: "500",
                }}
              >
                {group}
              </span>
            ))}
          </div>
        </motion.div>

        {/* Content Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 400px",
            gap: "32px",
            marginBottom: "48px",
          }}
        >
          {/* Sol - Hizmetler */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2
              style={{
                fontSize: "1.75rem",
                fontWeight: "700",
                color: "#0f172a",
                marginBottom: "24px",
              }}
            >
              Verilen Hizmetler
            </h2>

            {/* Ana Hizmet Kartları */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "16px",
                marginBottom: "32px",
              }}
            >
              {services.map((service, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.3 + index * 0.1 }}
                  style={{
                    backgroundColor: "white",
                    borderRadius: "16px",
                    padding: "24px",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.04)",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "12px",
                      backgroundColor: "#d1fae5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <service.icon size={24} color="#059669" />
                  </div>
                  <h3
                    style={{
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      color: "#0f172a",
                      marginBottom: "8px",
                    }}
                  >
                    {service.title}
                  </h3>
                  <p
                    style={{
                      fontSize: "0.9rem",
                      color: "#64748b",
                      lineHeight: "1.6",
                      margin: 0,
                    }}
                  >
                    {service.description}
                  </p>
                </motion.div>
              ))}
            </div>

            {/* Ek Hizmetler Listesi */}
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "16px",
                padding: "24px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.04)",
                border: "1px solid #f1f5f9",
              }}
            >
              <h3
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  color: "#0f172a",
                  marginBottom: "16px",
                }}
              >
                Diğer Hizmetlerimiz
              </h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {additionalServices.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "12px",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#d1fae5",
                        borderRadius: "6px",
                        width: "24px",
                        height: "24px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        marginTop: "2px",
                      }}
                    >
                      <FiCheck size={14} color="#059669" />
                    </div>
                    <span
                      style={{
                        color: "#475569",
                        fontSize: "0.95rem",
                        lineHeight: "1.5",
                      }}
                    >
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>

          {/* Sağ - Slider */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            style={{ position: "sticky", top: "160px", height: "fit-content" }}
          >
            {/* Image Slider */}
            <div
              style={{
                position: "relative",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                marginBottom: "16px",
              }}
            >
              <img
                src={images[currentSlide]}
                alt={`DIRFloortime ${currentSlide + 1}`}
                style={{
                  width: "100%",
                  height: "300px",
                  objectFit: "cover",
                  display: "block",
                }}
              />

              {/* Navigation Arrows */}
              <button
                onClick={prevSlide}
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  border: "none",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                }}
              >
                <FiChevronLeft size={20} color="#0f172a" />
              </button>
              <button
                onClick={nextSlide}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  border: "none",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                }}
              >
                <FiChevronRight size={20} color="#0f172a" />
              </button>

              {/* Dots */}
              <div
                style={{
                  position: "absolute",
                  bottom: "16px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  display: "flex",
                  gap: "8px",
                }}
              >
                {images.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    style={{
                      width: currentSlide === index ? "24px" : "8px",
                      height: "8px",
                      borderRadius: "4px",
                      backgroundColor:
                        currentSlide === index
                          ? "#059669"
                          : "rgba(255,255,255,0.6)",
                      border: "none",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                  />
                ))}
              </div>
            </div>

            {/* CTA Card */}
            <div
              style={{
                backgroundColor: "#ecfdf5",
                borderRadius: "16px",
                padding: "24px",
                border: "1px solid #a7f3d0",
              }}
            >
              <h4
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  color: "#047857",
                  marginBottom: "12px",
                }}
              >
                📞 Hemen İletişime Geçin
              </h4>
              <p
                style={{
                  fontSize: "0.9rem",
                  color: "#065f46",
                  marginBottom: "16px",
                  lineHeight: "1.5",
                }}
              >
                Çocuğunuz için özel bir terapi programı oluşturalım.
              </p>
              <a
                href="tel:+905055517747"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  backgroundColor: "#059669",
                  color: "white",
                  padding: "12px 20px",
                  borderRadius: "10px",
                  fontWeight: "600",
                  textDecoration: "none",
                  fontSize: "0.95rem",
                }}
              >
                <FiPhone size={18} />
                +90 505 551 77 47
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Responsive Style */}
      <style>
        {`
          @media (max-width: 900px) {
            section > div > div:nth-child(3) {
              grid-template-columns: 1fr !important;
            }
            section > div > div:nth-child(3) > div:last-child {
              position: relative !important;
              top: 0 !important;
            }
          }
          @media (max-width: 600px) {
            section > div > div:nth-child(3) > div:first-child > div:first-child {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Dir;
